import {default as Base} from "parent/src/js/base/Main";
import Initializer from "~/js/Controllers/Blocks/Initializer";

class Main extends Base {

    initializeBlocks() {
        return new Initializer();
    }
}

export default Main;
